import { CategoryViewAll } from '@/app/elements/category-view-all';
import type { MlRecommendationTracking } from '@/types/tracking/ml-recommendation';
import type { RotatingTitles } from '@/types/zones/zone';
import { RotatingZoneTitle } from './rotating-zone-title.client';

import './styles/@theme';

type ZoneHeaderProps = {
    title?: string;
    subtitle?: string;
    categoryUid?: string;
    rotatingTitles?: RotatingTitles;
    zoneUid?: string;
    mlRecommendation?: MlRecommendationTracking | null;
};

export const ZoneHeader = ({
    title,
    subtitle,
    categoryUid,
    rotatingTitles,
    zoneUid,
    mlRecommendation
}: ZoneHeaderProps) => {
    const rotatingTitleList =
        rotatingTitles?.enabled && rotatingTitles.titles.length > 1 ? rotatingTitles.titles : null;

    return (
        title && (
            <div data-testid="zone-header" className="zone__header">
                <div className="zone__header__title">
                    <h2>
                        {rotatingTitleList ? <RotatingZoneTitle titles={rotatingTitleList} zoneKey={zoneUid} /> : title}
                    </h2>
                    {categoryUid && (
                        <CategoryViewAll
                            categoryUid={categoryUid}
                            zoneName={title}
                            mlRecommendation={mlRecommendation}
                        />
                    )}
                    {/* TODO: subtitle for jackpots zone */}
                </div>
                {subtitle && <p data-testid="zone-header-subtitle">{subtitle}</p>}
            </div>
        )
    );
};
